/* Core & libraries */
import React from "react";
import { FormattedMessage } from "react-intl";
import {useNavigate} from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch }  from "../endpoints/base";
import { useNotificationContext } from "../contexts/notificationContext";

import {
  POST_ESCALATION_FORM_ENDPOINT,
  GET_OPTIONS_ENDPOINT,
} from "../endpoints/endpoints";
import {ESCALATION_MESSAGE_ROUTE} from "../constants/routes";

/* Components */
/* Styles */

export const useEscalationService = ()=> {
  const { genericApiFetch } = useGenericApiFetch();
  const { setNotification } = useNotificationContext();
  const navigate = useNavigate();

  const postEscalationForm = async (escalationData) => {
    const response = await genericApiFetch({
      url: POST_ESCALATION_FORM_ENDPOINT,
      method: "POST",
      data : escalationData,
      spinner: "escalationFormSpinner"
    });
    if (response.success) {
      navigate('../' + ESCALATION_MESSAGE_ROUTE);
      return true
    }

    setNotification(
      "error",
      <FormattedMessage id="notifications.sendEscalationErrorTitle" />,
      <FormattedMessage id="notifications.sendEscalationErrorDescription" />
    )
    return false;
  };

  const getTopicOptions = async (options) => {
      const response = await genericApiFetch({
        url: GET_OPTIONS_ENDPOINT,
        queryParams: {
          optionName: options,
        },
        method: 'GET',
      });
  
      if (response.success) {
        return response?.data?.options;
      }
      setNotification(
        'error',
        <FormattedMessage id="notifications.genericTitle" />,
        <FormattedMessage id="notifications.genericDescription" />,
      );
      return false;
    };

  return {
    postEscalationForm,
    getTopicOptions
  };
}

